// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"styles_tabContainer__1DZvL","tab":"styles_tab__3hAC8","header":"styles_header__1SELF","active":"styles_active__3kzvj"};